import {
	MdPayments,
	MdPeopleAlt,
	MdReceiptLong,
	MdHorizontalSplit,
} from 'react-icons/md';
import { FaHome, FaWallet, FaMoneyBill } from 'react-icons/fa';
import { IoIosPeople, IoMdSettings } from 'react-icons/io';
import constant from '../../utils/constant';
import { AiFillContainer } from 'react-icons/ai';
import { SlLink } from 'react-icons/sl';
import { BiWallet } from 'react-icons/bi';
import React from 'react';
import { TbMessage2Share } from 'react-icons/tb';
import { BsCalendarCheck } from 'react-icons/bs';
import { MdAccountBalance } from 'react-icons/md';
import { GiExpander } from 'react-icons/gi';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import { TiArrowRepeatOutline } from 'react-icons/ti';

export const SidebarData = [
	{
		title: 'Home',
		module: 'TRANSACTION',
		type: 'GENERAL',
		icon: <FaHome />,
		link: constant.Routes.AppHome,
	},
	{
		title: 'Customer',
		module: 'CUSTOMER',
		icon: <MdPeopleAlt />,
		link: constant.Routes.Customer,
	},
	{
		title: 'Invoice & Accounting ',
		// module: 'ACCOUNTING',
		type: 'GENERAL',
		icon: <MdAccountBalance />,
		link: constant.Routes.Invoice,
		subNav: [
			{
				title: 'Invoice / Receipt',
				module: 'INVOICE/RECEIPT',
				icon: <MdReceiptLong />,
				link: constant.Routes.Invoice,
			},
			{
				title: 'Wallet',
				module: 'WALLET',
				type: 'GENERAL',
				icon: <FaWallet />,
				link: constant.Routes.Wallet,
			},
			{
				title: 'Petty Cash',
				module: 'PETTY CASH',
				type: 'GENERAL',
				icon: <BiWallet />,
				link: constant.Routes.Subwallet,
			},
			{
				title: 'Transactions',
				module: 'TRANSACTION',
				type: 'GENERAL',
				icon: <MdPayments />,
				link: constant.Routes.Transactions,
			},
			{
				title: 'Client Plans & Billing',
				module: 'TRANSACTION',
				type: 'GENERAL',
				icon: <TiArrowRepeatOutline />,
				link: constant.Routes.Billing,
			},
		],
	},
	{
		title: 'Orders',
		// module: 'ORDERS',
		icon: <AiOutlineShoppingCart />,
		link: constant.Routes.Orders,
	},
	{
		title: 'Payment Link',
		module: 'PAYMENT-LINK',
		icon: <SlLink />,
		link: constant.Routes.PaymentLink,
	},
	{
		title: 'Booking',
		module: 'PAYMENT-LINK',
		icon: <BsCalendarCheck />,
		link: constant.Routes.Booking,
	},

	{
		title: 'Paybills',
		module: 'BILL PAYMENT',
		type: 'GENERAL',
		icon: <FaMoneyBill />,
		link: constant.Routes.PayBills,
	},
	{
		title: 'Stock',
		module: 'INVENTORY',
		icon: <AiFillContainer />,
		link: constant.Routes.Inventory,
	},
	{
		title: 'Split Payments',
		module: 'SPLIT-TRANSACTION',
		icon: <MdHorizontalSplit />,
		link: constant.Routes.SplitPayments,
	},
	{
		title: 'Employees',
		module: 'EMPLOYEE',
		icon: <IoIosPeople />,
		link: constant.Routes.Employees,
	},
	{
		title: 'Payroll',
		module: 'PAYROLL',
		icon: <IoIosPeople />,
		link: constant.Routes.Payroll,
	},
	{
		title: 'Vendor',
		module: 'VENDOR',
		icon: <MdPeopleAlt />,
		link: constant.Routes.Vendor,
	},
	{
		title: 'Bulk SMS',
		module: 'CUSTOMER',
		icon: <TbMessage2Share />,
		link: constant.Routes.BulkSms,
	},
	{
		title: 'Settings',
		icon: <IoMdSettings />,
		type: 'GENERAL',
		link: constant.Routes.Settings,
	},
];

export const ExpiredSidebarData = [
	{
		title: 'Paybills',
		module: 'BILL PAYMENT',
		type: 'GENERAL',
		icon: <FaMoneyBill />,
		link: constant.Routes.PayBills,
	},
	{
		title: 'Subscription Expiry',
		// module: 'BILL PAYMENT',
		type: 'GENERAL',
		icon: <GiExpander />,
		link: constant.Routes.SubExpired,
	},
];
